/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DigitizingMelcoDigitizingModelsOrderAttachment,
    DigitizingMelcoDigitizingModelsOrderAttachmentFromJSON,
    DigitizingMelcoDigitizingModelsOrderAttachmentFromJSONTyped,
    DigitizingMelcoDigitizingModelsOrderAttachmentToJSON,
} from './';

/**
 * 
 * @export
 * @interface DigitizingMelcoDigitizingModelsOrderCreate
 */
export interface DigitizingMelcoDigitizingModelsOrderCreate {
    /**
     * 
     * @type {DigitizingMelcoDigitizingModelsOrderAttachment}
     * @memberof DigitizingMelcoDigitizingModelsOrderCreate
     */
    attachment?: DigitizingMelcoDigitizingModelsOrderAttachment;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderCreate
     */
    garment_type_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderCreate
     */
    position_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderCreate
     */
    delivery_option_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderCreate
     */
    output_format_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderCreate
     */
    width?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderCreate
     */
    height?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderCreate
     */
    instructions?: string | null;
}

export function DigitizingMelcoDigitizingModelsOrderCreateFromJSON(json: any): DigitizingMelcoDigitizingModelsOrderCreate {
    return DigitizingMelcoDigitizingModelsOrderCreateFromJSONTyped(json, false);
}

export function DigitizingMelcoDigitizingModelsOrderCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingMelcoDigitizingModelsOrderCreate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'attachment': !exists(json, 'attachment') ? undefined : DigitizingMelcoDigitizingModelsOrderAttachmentFromJSON(json['attachment']),
        'garment_type_id': !exists(json, 'garment_type_id') ? undefined : json['garment_type_id'],
        'position_id': !exists(json, 'position_id') ? undefined : json['position_id'],
        'delivery_option_id': !exists(json, 'delivery_option_id') ? undefined : json['delivery_option_id'],
        'output_format_id': !exists(json, 'output_format_id') ? undefined : json['output_format_id'],
        'width': !exists(json, 'width') ? undefined : json['width'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'instructions': !exists(json, 'instructions') ? undefined : json['instructions'],
    };
}

export function DigitizingMelcoDigitizingModelsOrderCreateToJSON(value?: DigitizingMelcoDigitizingModelsOrderCreate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'attachment': DigitizingMelcoDigitizingModelsOrderAttachmentToJSON(value.attachment),
        'garment_type_id': value.garment_type_id,
        'position_id': value.position_id,
        'delivery_option_id': value.delivery_option_id,
        'output_format_id': value.output_format_id,
        'width': value.width,
        'height': value.height,
        'instructions': value.instructions,
    };
}


